// src/App.js
import React from 'react';
import ChatInterface from './Components/ChatInterface';


function App() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <ChatInterface/>
    </div>
  );
}

export default App;
